
import { post } from '../utils/http';

export function userResetPassword(param) {
    return post('resestPassword', param);
}